/* global s */
'use strict';

class HowToUse {
	constructor(options) {
		let _that = Object.assign(this, options);
		console.log('HowToUse(%o)', _that);

		const compatible_device_triggers = document.getElementById('compatible_device_triggers');
		const compatible_device_list = document.getElementById('compatible_device_brands');
		if (compatible_device_triggers && compatible_device_list) {
			const brand_triggers = compatible_device_triggers.querySelectorAll('.brand');
			const brands_details = compatible_device_list.querySelectorAll('.brand_details');
			brand_triggers.forEach(brand_trigger => {
				brand_trigger.addEventListener('click', e => {
					brand_triggers.forEach(brand => {
						brand.classList.remove('active');
					});
					brand_trigger.classList.add('active');
					compatible_device_triggers.classList.add('selected');

					brands_details.forEach(brand_details => {
						if (brand_details.dataset.brand === e.target.dataset.brand) {
							brand_details.classList.remove('d-none');
						} else {
							brand_details.classList.add('d-none');
						}
					});
				});
			})
		}

		if (window.location.hash === '#device-compatibility' && document.getElementById('device-compatibility')) {
			s.common.scrollToAnchor('device-compatibility');
		}
	}
}
